export default __webpack_public_path__ + "static/media/average_breakfast@2x.9be2e5f3.png";